import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAgentProfile } from 'utils/apis/agent-profile';

const initialState = {
    error: null,
    data: {},
    loading: false
};

export const fetchAgentProfile = createAsyncThunk('agentProfile/fetchAgentProfile', async (memberCode, thunkApi) => {
    try {
        const data = await getAgentProfile(memberCode);
        return data;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message || 'something went wrong');
    }
});

const agentProfileSlice = createSlice({
    name: 'agentProfile',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchAgentProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAgentProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.data = action.payload;
            })
            .addCase(fetchAgentProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export default agentProfileSlice.reducer;
